import { cn } from "@unlikelyai-magic/utils";

/**
 * Numbered badge component for message items
 */
export const NumberBadge = ({
  number,
  isSelected,
}: {
  number: number;
  isSelected: boolean;
}) => (
  <div
    className={cn(
      "flex h-4 w-4 items-center justify-center rounded-full text-[10px] font-medium text-white transition-colors",
      isSelected ? "bg-brand-primary" : "bg-brand-muted"
    )}
  >
    {number}
  </div>
);
